const availabilityCheck = async (address: string | undefined, postcode: string | undefined) => {
  return await fetch(`/api/leads/checkavailability?address=${address}&postcode=${postcode}`)
    .then((response) => {
      if (!response.ok) {
        throw Error('Somthing went wrong with the API call');
      } else {
        return response.json();
      }
    })
    .then((response) => {
      return {
        availabilitycode: response.data.availabilitycode,
        partnerId: response.data.partnerid.toString(),
      };
    })
    .catch((error) => {
      return error;
    });
};

export default availabilityCheck;
